module.exports = "/assets/cda4774d79df76d9c5ab2dfba3784155.png";